// eslint-disable-next-line no-restricted-imports
import { useBoxClient, useToast } from 'hooks';
import { messages } from 'i18n';
import { getFileIsHidden } from 'broker/components/FilesExplorer/utils';
import { useFetchSubmissionFiles } from 'broker/pages/SubmissionWorkspacePage/hooks/useFetchSubmissionFiles';

export function useDownloadFiles() {
  const boxClient = useBoxClient();
  const { showToast } = useToast();
  const { items: filesToDownload } = useFetchSubmissionFiles();

  return async (downloadFileName?: string) => {
    try {
      if (filesToDownload.length === 0) {
        return null;
      }
      // Remove hidden files from the root folder
      const nonHiddenFiles = filesToDownload.filter((file) => file.type === 'folder' || !getFileIsHidden(file));
      return await boxClient.createZip(nonHiddenFiles, downloadFileName);
    } catch (error) {
      showToast('error', { message: messages.general.operationFailed });
      return null;
    }
  };
}
